export const ARTICLES = [
  {
    slug: "llc-in-florida-gruenden",
    category: "Unternehmensgründung",
    title: "LLC in Florida gründen: Der Leitfaden für Deutsche & Schweizer",
    description:
      "Schritt für Schritt zur eigenen LLC in Florida: Unternehmensform, Registered Agent, EIN und Bankkonto – verständlich erklärt auf Deutsch.",
    date: "2026-10-18",
    readingTime: "7 Min.",
    sections: [
      {
        heading: "Warum gründen so viele in Florida?",
        paragraphs: [
          "Florida zieht Unternehmerinnen und Unternehmer aus Deutschland und der Schweiz an – und das nicht nur wegen des Wetters. Der Bundesstaat erhebt keine persönliche Einkommensteuer, die Bürokratie bei der Gründung ist vergleichsweise schlank, und die Gründung ist komplett aus dem Ausland möglich.",
          "Für Auswanderer ist die LLC (Limited Liability Company) meist die erste Wahl: Sie trennt Privat- und Firmenvermögen, ist flexibel in der Führung und steuerlich unkompliziert.",
        ],
      },
      {
        heading: "LLC oder Corporation – was passt zu Ihnen?",
        paragraphs: [
          "Die LLC eignet sich für die meisten Gründerinnen, Gründer und kleinen bis mittleren Unternehmen. Eine Corporation (z. B. eine C-Corp) lohnt sich vor allem dann, wenn Sie externe Investoren an Bord holen oder starkes Wachstum mit Anteilsverkäufen planen.",
          "Die Entscheidung hat steuerliche Folgen – auch in Ihrem Heimatland. Genau hier lohnt sich eine Beratung, die beide Seiten kennt: die US-Gründung und Ihre Situation in Deutschland oder der Schweiz.",
        ],
      },
      {
        heading: "Die Gründung Schritt für Schritt",
        list: [
          "Firmennamen prüfen und festlegen",
          "Registered Agent bestellen (in Florida Pflicht)",
          "Articles of Organization beim Staat Florida einreichen (Sunbiz)",
          "Operating Agreement erstellen – die internen Spielregeln Ihrer LLC",
          "EIN (Steuernummer) bei der IRS beantragen",
          "Geschäftskonto eröffnen",
        ],
      },
      {
        heading: "Kosten und laufende Pflichten",
        paragraphs: [
          "Die staatlichen Gründungsgebühren in Florida liegen im niedrigen dreistelligen Bereich. Dazu kommen je nach Konstellation Kosten für den Registered Agent, Beratung und Bank. Wichtig: Jede LLC in Florida muss einmal jährlich einen Annual Report einreichen – wird er vergessen, drohen Strafgebühren und im schlimmsten Fall die Auflösung der Gesellschaft.",
        ],
      },
      {
        heading: "Die drei häufigsten Fehler",
        list: [
          "Kein zuverlässiger Registered Agent – wichtige Post geht verloren",
          "Das US-Bankkonto wird unterschätzt: Ohne gute Vorbereitung scheitern viele an der Kontoeröffnung",
          "Steuerpflichten in Deutschland oder der Schweiz werden vergessen – Stichwort Doppelbesteuerungsabkommen und Meldepflichten",
        ],
      },
      {
        heading: "Wie wir Sie begleiten",
        paragraphs: [
          "Wir übernehmen die komplette Gründungsbegleitung auf Deutsch: von der Wahl der Unternehmensform über Registrierung und EIN bis zum Bankkonto – und bleiben auch danach an Ihrer Seite. Hinweis: Dieser Artikel dient der Orientierung und ersetzt keine Rechts- oder Steuerberatung.",
        ],
      },
    ],
  },
  {
    slug: "e2-visum-unternehmer",
    category: "Immigration",
    title: "E-2-Visum für Unternehmer: Voraussetzungen & Ablauf",
    description:
      "Mit dem E-2-Visum können Deutsche und Schweizer in den USA leben und ihr eigenes Unternehmen führen. Voraussetzungen, Ablauf und typische Fallstricke.",
    date: "2026-10-18",
    readingTime: "6 Min.",
    sections: [
      {
        heading: "Was ist das E-2-Visum?",
        paragraphs: [
          "Das E-2-Visum ist ein sogenanntes Treaty-Investor-Visum. Deutschland und die Schweiz gehören zu den Vertragsstaaten – Staatsangehörige beider Länder können es beantragen. Es erlaubt Ihnen, in den USA zu leben und ein Unternehmen zu führen, in das Sie investiert haben.",
        ],
      },
      {
        heading: "Die wichtigsten Voraussetzungen",
        list: [
          "Staatsangehörigkeit eines Vertragsstaates (Deutschland und die Schweiz erfüllen dies)",
          "Eine substanzielle Investition in ein US-Unternehmen – es gibt keinen fixen Mindestbetrag; entscheidend ist, dass die Summe für das jeweilige Geschäft ausreicht und das Risiko real ist",
          "Das Unternehmen muss real und aktiv operieren (oder kurz davor stehen)",
          "Sie kontrollieren das Unternehmen (mindestens 50 % oder operative Kontrolle)",
          "Das Unternehmen darf nicht marginal sein: Es muss mehr erwirtschaften als nur Ihren Lebensunterhalt",
        ],
      },
      {
        heading: "Der Ablauf in fünf Schritten",
        list: [
          "Unternehmenskonzept und Investitionsplan erstellen",
          "US-Unternehmen gründen und die Investition tatsächlich leisten",
          "Antragsunterlagen zusammenstellen (u. a. Businessplan und Investitionsnachweise)",
          "Antrag beim zuständigen US-Konsulat einreichen – für Deutschland typischerweise Frankfurt, für die Schweiz Bern",
          "Visum-Interview und Entscheidung",
        ],
      },
      {
        heading: "Laufzeit, Familie und Verlängerung",
        paragraphs: [
          "Das E-2-Visum wird für mehrere Jahre erteilt und kann unbegrenzt verlängert werden, solange die Voraussetzungen bestehen. Ihre Ehepartnerin oder Ihr Ehepartner darf in den USA arbeiten, Kinder bis 21 Jahre können mitreisen und zur Schule gehen. Wichtig zu wissen: Das E-2-Visum führt nicht automatisch zur Green Card.",
        ],
      },
      {
        heading: "Typische Fallstricke",
        paragraphs: [
          "Die häufigsten Ablehnungsgründe sind eine nicht ausreichend nachgewiesene Investition, ein zu schwacher Businessplan oder ein Unternehmen, das als marginal eingestuft wird. Wir bereiten Ihren Fall strukturiert vor und begleiten die komplette Antragstellung. Hinweis: Dieser Artikel dient der Orientierung.",
        ],
      },
    ],
  },
  {
    slug: "relocation-checkliste-florida",
    category: "Relocation",
    title: "Relocation-Checkliste: Die ersten 30 Tage in Florida",
    description:
      "Ankommen ohne Stress: Unterkunft, Krankenversicherung, Führerschein, Bankkonto – die wichtigsten Schritte nach Ihrer Ankunft in Florida.",
    date: "2026-10-18",
    readingTime: "6 Min.",
    sections: [
      {
        heading: "Vor der Abreise: Das Fundament legen",
        list: [
          "Wichtige Dokumente zusammenstellen: Pässe, Geburtsurkunden, Heiratsurkunde, Zeugnisse – teils mit beglaubigter Übersetzung oder Apostille",
          "Versicherungen und Verträge in der Heimat kündigen oder ruhend stellen",
          "Krankenversicherung für die USA klären – es gibt keine Pflichtversicherung wie in der Schweiz oder Deutschland",
          "Vorläufige Unterkunft für die ersten Wochen buchen",
        ],
      },
      {
        heading: "Woche 1: Ankommen und durchatmen",
        paragraphs: [
          "Richten Sie zuerst das Alltägliche ein: US-SIM-Karte, Mietwagen oder eigenes Fahrzeug – und erkunden Sie Ihre Nachbarschaft. Nehmen Sie sich Zeit: Die erste Woche ist fürs Ankommen da, nicht für Perfektion.",
        ],
      },
      {
        heading: "Woche 2: Der Papierkram",
        list: [
          "Bankkonto eröffnen (mit Pass und persönlichen Unterlagen bzw. EIN)",
          "Social Security Number beantragen, sofern für Ihren Status vorgesehen",
          "Kranken-, Auto- und Haftpflichtversicherung abschliessen",
          "Für Unternehmer: Geschäftskonto und Buchhaltung einrichten",
        ],
      },
      {
        heading: "Woche 3–4: Den Alltag einrichten",
        list: [
          "Florida-Führerschein beantragen – Neuzuzüger müssen ihren Führerschein innerhalb kurzer Frist umschreiben",
          "Strom, Wasser und Internet anmelden",
          "Bei Familien: Schulen besichtigen und Anmeldung starten",
          "Hausarzt und wichtige Anlaufstellen in der Nähe finden",
        ],
      },
      {
        heading: "Danach: Wirklich ankommen",
        paragraphs: [
          "Relocation endet nicht mit dem Papierkram. Netzwerke, Sprache und Routinen machen Florida zur Heimat. Genau deshalb bleiben wir auch nach Ihrer Auswanderung an Ihrer Seite – persönlich und auf Deutsch.",
        ],
      },
    ],
  },
  {
    slug: "auswandern-florida-mit-familie",
    category: "Familie",
    title: "Auswandern nach Florida mit Familie: Visum, Schule & Alltag",
    description:
      "Auswandern nach Florida mit Familie: Welches Visum gilt für Ehepartner und Kinder, wie das Schulsystem funktioniert und was Sie im Alltag erwartet.",
    date: "2026-10-19",
    readingTime: "6 Min.",
    sections: [
      {
        heading: "Das Visum für die ganze Familie",
        paragraphs: [
          "Bei den meisten Unternehmer-Visa reist die Familie mit: Beim E-2 Visum erhält Ihre Ehepartnerin oder Ihr Ehepartner ein eigenes Visum und darf uneingeschränkt arbeiten – auch bei anderen Arbeitgebern. Kinder bis 21 Jahre reisen mit und dürfen zur Schule gehen und studieren. Bei Green-Card-Wegen wie EB-2 NIW oder EB-1C bekommt die Familie die Green Card gleich mit.",
        ],
      },
      {
        heading: "Das Schulsystem in Florida",
        paragraphs: [
          "Kinder von Visumsinhabern besuchen in der Regel die öffentliche Schule ihres Wohngebiets – die Schulqualität hängt stark vom Schulbezirk ab. Deshalb lohnt es sich, die Wohnungswahl auch nach der Schule auszurichten. Wir helfen Ihnen, Bezirk und Anmeldung richtig anzugehen.",
        ],
      },
      {
        heading: "Krankenversicherung für die Familie",
        paragraphs: [
          "Es gibt keine Pflichtversicherung wie in der Schweiz oder Deutschland – und ohne Versicherung wird medizinische Versorgung schnell teuer. Klären Sie den Versicherungsschutz für die ganze Familie, bevor Sie abreisen. Details dazu finden Sie in unserem Ratgeber zur Krankenversicherung.",
        ],
      },
      {
        heading: "Ankommen als Familie",
        paragraphs: [
          "Der Umzug ans andere Ende des Atlantiks ist für Kinder eine grosse Umstellung – Sprache, Freunde, Routinen. Unsere Erfahrung: Familien kommen am besten an, wenn der Alltag schnell Struktur bekommt. Genau dabei unterstützen wir – von der Schulsuche bis zu den kleinen Fragen des Alltags.",
        ],
      },
    ],
  },
  {
    slug: "krankenversicherung-usa-einwanderer",
    category: "Relocation",
    title: "Krankenversicherung in den USA für Einwanderer: Überblick & Kosten",
    description:
      "Krankenversicherung USA für Einwanderer: Keine Pflichtversicherung wie in der Schweiz oder Deutschland – welche Optionen es gibt und wovon die Kosten abhängen.",
    date: "2026-10-19",
    readingTime: "5 Min.",
    sections: [
      {
        heading: "Kein System wie daheim",
        paragraphs: [
          "In den USA gibt es keine gesetzliche Pflichtversicherung wie in der Schweiz oder Deutschland. Wer unversichert ist, zahlt Arztbesuche und Spitalaufenthalte selbst – und das wird schnell sehr teuer. Für Auswanderer ist die Krankenversicherung deshalb eines der wichtigsten Themen überhaupt.",
        ],
      },
      {
        heading: "Ihre Optionen im Überblick",
        list: [
          "Versicherung über den Arbeitgeber – der häufigste Weg für Angestellte",
          "Marktplatz-Pläne (Affordable Care Act) – auch für Selbstständige und Neuankömmlinge",
          "Private Versicherungen und Auslandslösungen für die Übergangszeit",
          "Für Unternehmer: Absicherung über die eigene Firma oder den Marktplatz",
        ],
      },
      {
        heading: "Wovon die Kosten abhängen",
        paragraphs: [
          "Die Prämien variieren stark – je nach Alter, Bundesstaat, Familienstand und gewähltem Schutz. Pauschale Zahlen wären unseriös: Was in Ihrer Situation realistisch ist, rechnen wir im Rahmen Ihrer Relocation-Planung gemeinsam durch, bevor Sie sich entscheiden.",
        ],
      },
      {
        heading: "Unser Tipp für Auswanderer",
        paragraphs: [
          "Klären Sie die Absicherung vor der Abreise – idealerweise so, dass ab dem ersten Tag in Florida Schutz besteht. In unsere Relocation-Begleitung gehört die Versicherungsfrage immer dazu.",
        ],
      },
    ],
  },
  {
    slug: "steuern-auswanderung-usa-dba",
    category: "Finanzen",
    title: "Steuern bei der Auswanderung in die USA: Das DBA einfach erklärt",
    description:
      "Doppelbesteuerungsabkommen USA – Deutschland & Schweiz: Was Auswanderer über Steuern beim Wegzug und nach der Ankunft wissen müssen – verständlich erklärt.",
    date: "2026-10-19",
    readingTime: "6 Min.",
    sections: [
      {
        heading: "Das Doppelbesteuerungsabkommen (DBA)",
        paragraphs: [
          "Deutschland und die Schweiz haben mit den USA ein Doppelbesteuerungsabkommen. Es regelt, welches Land welche Einkünfte besteuern darf – und verhindert, dass Sie dieselben Einkünfte zweimal voll besteuern. Das Abkommen entbindet Sie aber nicht von den Meldepflichten: In der Regel bleiben Erklärungen in beiden Ländern nötig.",
        ],
      },
      {
        heading: "Steuern beim Wegzug",
        paragraphs: [
          "Der Wegzug selbst kann steuerliche Folgen haben – etwa bei grösseren Firmenbeteiligungen (in Deutschland Stichwort Wegzugsbesteuerung) oder bei der Auflösung von Vorsorge- und Versicherungslösungen in der Schweiz. Was für Sie gilt, hängt von Ihrer persönlichen Situation ab und sollte vor dem Wegzug mit einer Steuerberaterin oder einem Steuerberater im Heimatland geklärt werden.",
        ],
      },
      {
        heading: "Steuern nach der Ankunft in den USA",
        paragraphs: [
          "In den USA werden Sie mit Ihrem weltweiten Einkommen steuerpflichtig, sobald Sie dort Ihren Lebensmittelpunkt haben oder eine Green Card besitzen. Positiv für Florida: Der Bundesstaat erhebt keine persönliche Einkommensteuer – es bleibt bei der Bundessteuer.",
        ],
      },
      {
        heading: "Unser Rat",
        paragraphs: [
          "Steuern sind das Thema, bei dem Auswanderer am häufigsten sparen – und später teuer dafür zahlen. Wir verzahnen Ihre Gründung und Ihren Umzug früh mit der Steuerfrage und arbeiten mit Steuerberatern auf beiden Seiten. Hinweis: Dieser Artikel ersetzt keine Steuerberatung.",
        ],
      },
    ],
  },
  {
    slug: "esta-visum-green-card-unterschied",
    category: "Immigration",
    title: "ESTA, Visum oder Green Card? Die Unterschiede einfach erklärt",
    description:
      "ESTA, Visum oder Green Card – was ist der Unterschied? Wer nach Florida auswandern will, braucht mehr als ESTA: die Übersicht für Deutsche und Schweizer.",
    date: "2026-10-19",
    readingTime: "5 Min.",
    sections: [
      {
        heading: "ESTA: Nur für Besuche",
        paragraphs: [
          "ESTA ist die elektronische Einreiseerlaubnis für Touristen und Geschäftsreisende: bis zu 90 Tage Aufenthalt, keine Arbeit, kein Umzug. Wer mit ESTA einreist und dann in den USA arbeitet oder wohnen bleibt, riskiert Einreiseverbote. Für eine Auswanderung ist ESTA nie der richtige Weg.",
        ],
      },
      {
        heading: "Visum: Befristet, aber mit echtem Zweck",
        paragraphs: [
          "Ein Visum wie E-2 oder L-1A erlaubt Ihnen, in den USA zu leben und zu arbeiten – gebunden an Ihren Zweck, etwa Ihr Unternehmen. Es ist befristet, aber je nach Kategorie unbegrenzt verlängerbar (E-2) oder ein Sprungbrett zur Green Card (L-1A über EB-1C).",
        ],
      },
      {
        heading: "Green Card: Die unbefristete Aufenthalts- und Arbeitserlaubnis",
        paragraphs: [
          "Die Green Card macht Sie zur Permanent Resident: unbefristet leben und arbeiten, unabhängig von einem bestimmten Unternehmen. Für Unternehmer sind die direkten Wege EB-2 NIW und EB-1C besonders interessant – beide ohne Lotterie.",
        ],
      },
      {
        heading: "Welcher Weg passt zu Ihnen?",
        paragraphs: [
          "Kurz gesagt: Besuch – ESTA. Gründen und leben – Visum. Dauerhaft bleiben – Green Card. Welcher Einstieg für Ihre Situation sinnvoll ist, prüfen wir im kostenlosen Erstgespräch – ehrlich und auf Deutsch.",
        ],
      },
    ],
  },
  {
    slug: "lebenskosten-florida",
    category: "Leben in Florida",
    title: "Leben in Florida: Was kostet das wirklich? Die ehrliche Kosten-Übersicht",
    description:
      "Lebenskosten in Florida ehrlich aufgeschlüsselt: Wohnen, Krankenversicherung, Auto, Steuern und Alltag – mit realistischen Zahlen für Auswanderer aus Deutschland und der Schweiz.",
    date: "2026-10-19",
    readingTime: "8 Min.",
    sections: [
      {
        heading: "Wohnen: Der grösste Posten im Budget",
        paragraphs: [
          "Die Mieten in Florida unterscheiden sich stark nach Region: An der Westküste – Sarasota, Fort Myers, Naples – zahlen Sie für eine gute Wohnung oder ein Haus zur Miete typischerweise zwischen 2.000 und 3.500 US-Dollar im Monat, je nach Lage und Grösse. Direkt am Wasser oder in Miami liegt man deutlich höher, im Landesinneren spürbar tiefer.",
          "Wer kauft, sollte neben dem Kaufpreis die laufenden Kosten kennen: Grundsteuer (Property Tax), Hausversicherung – in Florida wegen der Hurrikan-Lage ein ernstzunehmender Posten – und je nach Wohnanlage monatliche Gebühren (HOA).",
        ],
      },
      {
        heading: "Krankenversicherung: Der wichtigste Unterschied zu Europa",
        paragraphs: [
          "Kein Posten überrascht Auswanderer so sehr wie die Krankenversicherung. Je nach Alter, Familienstand und Tarif liegen die monatlichen Prämien für eine Familie grob zwischen 1.000 und 2.500 US-Dollar. Das klingt nach viel – lässt sich aber mit kluger Tarifwahl und der richtigen Struktur (etwa über die eigene Firma) deutlich optimieren.",
          "Unser Ratgeber zur Krankenversicherung für Einwanderer erklärt die Optionen im Detail. Wichtig: Ohne Versicherung wird jeder Arztbesuch zum finanziellen Risiko – hier spart man am falschen Ort.",
        ],
      },
      {
        heading: "Auto, Steuern und Alltag",
        list: [
          "Auto: Ohne Auto geht in Florida fast nichts – Leasing oder Kauf plus Versicherung sind ein fester Posten",
          "Steuern: Florida erhebt keine staatliche Einkommensteuer – ein echter Vorteil gegenüber vielen US-Staaten und Europa",
          "Lebensmittel & Alltag: in etwa vergleichbar mit Deutschland, Restaurants und Dienstleistungen oft günstiger als in der Schweiz",
          "Strom: Klimaanlagen laufen fast das ganze Jahr – 150 bis 300 Dollar monatlich sind je nach Haus normal",
          "Schule: öffentliche Schulen sind kostenlos; private Schulen kosten extra",
        ],
      },
      {
        heading: "Beispiel-Budget: Familie mit zwei Kindern",
        paragraphs: [
          "Eine vierköpfige Familie an der Westküste Floridas sollte realistisch mit 6.000 bis 9.000 US-Dollar monatlich rechnen – inklusive Wohnen, Krankenversicherung, zwei Autos und normalem Lebensstil. Wer am Wasser wohnen und privat versichern möchte, liegt höher; wer kompakt startet, kommt mit weniger aus.",
          "Entscheidend ist: Diese Zahlen gehören in Ihren Businessplan und Ihre Auswanderungsplanung – nicht als Überraschung danach.",
        ],
      },
      {
        heading: "Unser Fazit",
        paragraphs: [
          "Florida ist günstiger als viele denken – und teurer, als manche hoffen. Wer die Zahlen vorher ehrlich durchrechnet, startet ohne böse Überraschungen. Genau das machen wir mit Ihnen im Erstgespräch: Ihre Lebenshaltung, Ihr Geschäft und Ihr Visum als eine Gesamtrechnung – auf Deutsch. Hinweis: Dieser Artikel dient der Orientierung; alle Zahlen sind Richtwerte.",
        ],
      },
    ],
  },
  {
    slug: "auswandern-florida-mit-unternehmen",
    category: "Immigration",
    title: "Auswandern nach Florida mit eigenem Unternehmen: So funktioniert's",
    description:
      "Mit dem eigenen Unternehmen nach Florida auswandern: E-2 Visum als Weg, gründen oder kaufen, Businessplan und Ablauf – Schritt für Schritt erklärt auf Deutsch.",
    date: "2026-10-19",
    readingTime: "8 Min.",
    sections: [
      {
        heading: "Warum Unternehmer den direktesten Weg haben",
        paragraphs: [
          "Während Arbeitnehmer auf US-Firmen angewiesen sind, die sie sponsern, machen Unternehmer sich selbst zum Ticket: Mit einer eigenen, aktiv geführten Firma in den USA kommen Sie über das E-2 Visum ins Land – ohne Lotterie, ohne Arbeitgeber, unbegrenzt verlängerbar. Deutschland und die Schweiz sind beide E-2-Vertragsstaaten.",
          "Und weil das Visum an Ihr Unternehmen gebunden ist, entscheidet die Qualität Ihrer Unternehmensplanung direkt über Ihren Visumserfolg.",
        ],
      },
      {
        heading: "Gründen oder kaufen?",
        paragraphs: [
          "Beide Wege funktionieren fürs E-2 Visum. Die Neugründung gibt Ihnen maximale Freiheit und oft einen tieferen Kapitaleinsatz. Der Kauf eines bestehenden Business bringt nachweisbare Umsätze und Kunden mit – ein starkes Argument vor dem Konsulat. Was zu Ihnen passt, hängt von Erfahrung, Budget und Branche ab.",
          "Und falls Sie noch keine Geschäftsidee haben: Unsere fixfertigen Business-Ideen für Florida sind genau dafür gebaut – erprobte Konzepte, die zur Visumslogik passen.",
        ],
      },
      {
        heading: "Der Businessplan: Ihr wichtigstes Dokument",
        paragraphs: [
          "Das Konsulat prüft anhand Ihres Businessplans, ob Ihr Unternehmen echt ist, tragfähig funktioniert und mehr erwirtschaftet als nur Ihren Lebensunterhalt. Ein generischer Plan aus dem Internet ist einer der häufigsten Gründe für Rückfragen und Ablehnungen.",
          "Wir erstellen Ihren Businessplan individuell: mit echten Zahlen aus Ihrer Branche und Region, 5-Jahres-Finanzplanung und allem, was Konsulat und Bank sehen wollen.",
        ],
      },
      {
        heading: "Ihr Fahrplan Schritt für Schritt",
        list: [
          "Erstgespräch: Situation, Budget und Ziele klären – kostenlos und auf Deutsch",
          "Strategie: Gründung oder Kauf, Branche, Region und Zeitplan festlegen",
          "Firma gründen: LLC oder Corporation, EIN und Geschäftskonto",
          "Investition einsetzen: sauber dokumentiert und nachvollziehbar",
          "Businessplan erstellen: visumstauglich und bankfähig",
          "Antragstellung & Interview: komplett vorbereitet ans Konsulat",
          "Ankommen: Umzug, Wohnung, Versicherungen – mit unserem Relocation-Service",
        ],
      },
      {
        heading: "Die drei häufigsten Fehler",
        list: [
          "Zu spät mit der Firmenstruktur starten – Bankkonto und EIN brauchen Vorlauf",
          "Investition nicht sauber dokumentiert – das Konsulat will den Geldfluss sehen",
          "Businessplan als Pflichtübung behandeln statt als Herzstück des Antrags",
        ],
      },
      {
        heading: "Wie wir Sie begleiten",
        paragraphs: [
          "Von der ersten Idee bis weit nach der Visumserteilung: Strategie, Gründung, Businessplan, Antragstellung und Ankommen – alles aus einer Hand, alles auf Deutsch. Und danach bleiben wir an Ihrer Seite: mit laufender Beratung, Marketing und Kundengewinnung für Ihr Geschäft in Florida. Hinweis: Dieser Artikel dient der Orientierung.",
        ],
      },
    ],
  },
];

export function getArticle(slug) {
  return ARTICLES.find((a) => a.slug === slug);
}
